<template>
  <section class="mb-l">
    <h2 class="text-center mb-m section-title">投保年齡限制</h2>
    <div class="container">      
      <Table
        border
        class="mb-s table-wrapper"
        :data="table.data"
        :columns="table.columns"
      />
      <p 
        class="fz-tiny"
        :style="{ color: '#909399'}">
        您的年齡、險種及保額在上圖範圍內，但網路線上投保無法試算到對應專案組合者，請來電 (02)7707-8987 陳先生 辦理。
      </p>
    </div>
  </section> 
</template>

<script>
  import { Table } from 'iview';
  import { ageLimit } from '@/staticData/insuDescs';

  export default {
    components: { Table },
    data() {
      return {
        table: ageLimit
      };
    }
  };
</script>
